import { IDesignatedDoctorInformationSource, IDesignatedDoctorInformationSourceSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IXElementContentsObjectBean } from "../../../beans";
import { DesignatedDoctorTypeTranslator } from "./DesignatedDoctorTypeTranslator";

export class DesignatedDoctorInformationSourceTranslator {
  from(bean: IXElementContentsObjectBean): IDesignatedDoctorInformationSource {
    return {
      type: this.designatedDoctorType.from(bean),
    };
  }

  to(object: IDesignatedDoctorInformationSourceSpecifiable) {
    return {
      relationalDesignateDoctor: this.designatedDoctorType.to(object.designatedDoctorInformationSource.type),
    };
  }

  private readonly designatedDoctorType = new DesignatedDoctorTypeTranslator();
}
